import { forwardRef, type LabelHTMLAttributes } from 'react';
import clsx from 'clsx';

export const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={clsx('mb-1 block text-sm font-medium text-content-secondary', className)}
      {...props}
    />
  )
);

Label.displayName = 'Label';








